'use client';

import { Picture } from '@petsmart-ui/sparky';
import { getApplicationName, getIconSrc } from '../../utils';
import type { LegacyIconProps } from './types';

export function LegacyIcon({
    name,
    size,
    priority,
    className,
}: Readonly<LegacyIconProps>) {
    const pageType = getApplicationName();
    const iconSrc = getIconSrc(pageType ?? 'plp', name);
    // NOTE: Legacy icons are a mix between custom font icons with icomoon.io and png images.
    // As the legacy design is temporary, we don't want to invest time in creating a new icon system.
    return (
        <>
            {priority ? (
                <link rel="preload" key={iconSrc} href={iconSrc} as="image" />
            ) : null}
            <Picture
                data-testid="legacy-icon"
                imgSrc={iconSrc}
                imgAlt={`icon ${name}`}
                className={className}
                style={{
                    display: 'inline-block',
                    width: 'auto',
                }}
                imageComponentProps={{
                    loading: priority ? 'eager' : 'lazy',
                    style: {
                        width: size,
                        height: 'auto',
                    },
                }}
            />
        </>
    );
}
